import { MatchUnitSize } from '@uefadigital/panenka';
import clsx from 'clsx';
import { useMemo, memo } from 'react';

import { useWindowSize } from '@hooks/useWindowSize';
import { hydrateWithTranslations } from '@services/TranslatorService';
import type { MatchUnitProps } from '@shared/MatchUnit';
import MatchUnit from '@shared/MatchUnit';
import type { Match } from '@shared-types/match.types';
import { groupBy } from '@utilities/collection-utils';
import { dateToString } from '@utilities/dateTime';

import * as classes from './styles.module.scss';

const muOptions: MatchUnitProps['options'] = {
  showHighlights: true,
};

const groupByDate = (match: Match) => dateToString(match.kickOffTime.dateTime ?? match.kickOffTime.date, 'YYYY-MM-DD');

const StandingsMatches = ({ matches }: { matches: Match[] }) => {
  const { isDesktop } = useWindowSize();

  const muSize = useMemo(() => (isDesktop ? MatchUnitSize.L_PLUS : MatchUnitSize.S_PLUS), [isDesktop]);
  const groupedMatches = useMemo(() => groupBy(matches, groupByDate), [matches]);

  return (
    <div
      className={clsx(
        'pk-bg--ui-01',
        'pk-d--flex',
        'pk-flex--column',
        'pk-gap--l',
        'pk-p--m',
        'pk-p-sm--l',
        'pk-pt-sm--xl2',
        'pk-border-top',
      )}
    >
      {Object.entries(groupedMatches).map(([key, groupMatches]) => (
        <div key={key}>
          <div
            className={clsx(
              'pk-d--flex',
              'pk-justify-content--between',
              'pk-justify-content-sm--start',
              'pk-gap--l',
              'pk-line-height--md',
              'pk-font-size--m',
              'pk-font-size-sm--l',
              'pk-mb--m',
            )}
          >
            <div className='pk-font--base-semibold pk-text--text-01'>
              {hydrateWithTranslations(groupMatches[0].matchday)?.longName}
            </div>
            <div className='pk-font--base-regular pk-text--text-02'>{dateToString(key, 'D MMM')}</div>
          </div>
          <div className={classes.grid}>
            {groupMatches.map((match) => (
              <MatchUnit className={classes.matchUnit} key={match.id} match={match} size={muSize} options={muOptions} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(StandingsMatches);
